import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

type IGetMerchantUserPortfolioListResponse = BaseResponse<any>;

async function getMerchantUserPortfolioList(): Promise<IGetMerchantUserPortfolioListResponse> {
  try {
    const response = await axiosInstance.get("/Merchant/GetUserPortfolio");
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantUserPortfolioList() {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetAllMerchantList], 
    () => getMerchantUserPortfolioList()
  );
}
